<div class="user-profile-details" style="overflow-y: auto;">
<p-fieldset legend="eQMS Scope(s) Assignment" [toggleable]="true">
    <app-tree class="eQMS-scope" id="userProfileeQMSScope" [treeData]="treeData"></app-tree>
</p-fieldset>
<br>
<p-fieldset legend="Organization" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label  labelText="Manager"></app-label>
            <app-read-only *ngIf="userProfile?.managerUserName !== null" readonlyText="{{userProfile.managerUserName}}"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Direct Report(s)"></app-label>
            <app-read-only *ngFor="let directReport of userProfile?.directReporties" readonlyText="{{directReport}}"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Cost Center"></app-label>
            <app-read-only readonlyText="{{userProfile?.costCenter}}"></app-read-only>
        </div>
    </div>
</p-fieldset>
<br>
<p-fieldset legend="Security/Permissions" [toggleable]="true">
    <div class="col-3">
        <app-label labelText="Security/Permissions"></app-label>
        <app-read-only *ngFor="let securityPermission of userProfile?.securityPermissions" readonlyText="{{securityPermission}}"></app-read-only>
    </div>
</p-fieldset>
<br>
<p-fieldset legend="Dates" [toggleable]="true">
    <div class="grid">
        <div class="col-3">
            <app-label  labelText="Hire Date"></app-label>
            <app-read-only readonlyText="{{(userProfile?.hireDate| date: 'dd-MMM-yyyy') || notApplicableText}}"></app-read-only>
        </div>
        <div class="col-3">
            <app-label  labelText="Termination Date"></app-label>
            <app-read-only readonlyText="{{(userProfile?.terminationDate | date: 'dd-MMM-yyyy') || notApplicableText}}"></app-read-only>
        </div>
    </div>
    <div class="grid">
        <div class="col-3">
            <app-label  labelText="Last Training Plan Review Date"></app-label>
            <app-read-only readonlyText="{{(userProfile?.lastTrainingPlanReviewDate | date: 'dd-MMM-yyyy') || notApplicableText}}"></app-read-only>
        </div>
        <div class="col-3">
            <app-label labelText="Next Training Plan Review Date"></app-label>
            <app-read-only readonlyText="{{(userProfile?.nextTrainingPlanReviewDate |date: 'dd-MMM-yyyy') || notApplicableText}}"></app-read-only>
        </div>
    </div>
</p-fieldset>
<br>
<p-fieldset legend="Attachments" [toggleable]="true">
    <div *ngFor="let attachment of userProfile?.attachments" class="mt-1">
        <em class="blue-color cursor-pointer" (click)="downloadAttachment(attachment.attachmentFileId, attachment.attachmentName)"
          ><app-file-icon [fileType]="attachment.attachmentType"></app-file-icon
        ></em>
        <span class="ml-3">{{ attachment.attachmentName }}</span>
            <em
              class="ml-2 fa fa-trash blue-color cursor-pointer"
              (click)="deleteAttachment(attachment.attachmentId!)"
            ></em>
      </div>
</p-fieldset>
</div>

<app-confirmation [showConfirmationModal]="showConfirmationModal" [confirmationMessage]="confirmationMessage" (closeConfirmation)="closedConfirmation($event)" (confirm)="confirmDelete($event)"></app-confirmation>
